import classnames from 'classnames'
import styles from './index.module.css'

export const View = ({ className, isBorder, fontSize, label, ...props }) => {
    const style = {
        '--link-font-size': `${fontSize}px`
    }
    const isNewTab = props.target === '_blank'
    const borderClass = isBorder ? styles.border : ''

    // NOTE: react-router-domのLinkタグはAppkit4のTooltipでエラーになるためaタグで作成
    return (
        <a className={classnames(styles.default, borderClass, className)} style={style} {...props}>
            {label}
            {isNewTab && <span className={`Appkit4-icon icon-open-in-new-window-outline`} />}
        </a>
    )
}
